import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759e80bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, null, -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col d-flex flex-column justify-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tarifas de Manejo de Carga")
], -1))
const _hoisted_8 = { class: "card overflow-scroll" }
const _hoisted_9 = { class: "table table-hover table-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha Inicio"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha Final"),
    /*#__PURE__*/_createElementVNode("th", null, "Cargo"),
    /*#__PURE__*/_createElementVNode("th", null, "Descripcion"),
    /*#__PURE__*/_createElementVNode("th", null, "Aplica"),
    /*#__PURE__*/_createElementVNode("th", null, "Valor"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado"),
    /*#__PURE__*/_createTextVNode("e ")
  ])
], -1))

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { Cartarman } from '@/interface/interfaces'
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'TarManejo',
  setup(__props) {

const dUrl = UrlGlobal()

const tarifa = ref<Array<Cartarman>>([]);

const getTarifa = () => {
axios.get(dUrl.urlGlobal +'/api2/cartarman/')
  .then(response => {
    tarifa.value = response.data;
  })
  .catch(error => {
    console.error('Error al buscar Tarifas:', error);
  });
};



onMounted(() => {
getTarifa();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tarifa.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.tarifa
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_inicio), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_final), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_cargo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.aplica), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.valor), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.status), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})